import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css'; // Import AOS styles
import { Link } from 'react-router-dom'; // Import Link for navigation

const ComingSoon = () => {
  useEffect(() => {
    AOS.init({ duration: 1200 });
    AOS.refresh();
  }, []);

  return (
    <div className="flex items-center justify-center min-h-screen bg-gradient-to-r from-teal-400 to-purple-400 relative overflow-hidden">
      {/* Background Effect */}
      <div className="absolute inset-0 bg-opacity-40 backdrop-blur-md"></div>

      {/* Right Div for Coming Soon and Contact Info */}
      <div
        className="relative w-11/12 md:w-1/3 p-8 text-center bg-gradient-to-r from-teal-100 to-purple-200 rounded-xl shadow-xl backdrop-blur-lg mx-4 opacity-90 flex flex-col justify-center items-center"
        data-aos="fade-up"
      >
        <img
          src="https://ik.imagekit.io/7uve7qsipm/logo.png?updatedAt=1726140688919" // Update with your logo path
          alt="Gurukul ERP Logo"
          className="mb-6 h-48 w-auto rounded-full shadow-md" // Adjust height and style as needed
        />
        <h1 className="text-5xl font-bold text-teal-600 mb-2">Gurukul ERP</h1>
        <p className="text-gray-600 mb-4 text-lg">We are excited to launch soon! Stay tuned!</p>

        <h2 className="text-3xl font-semibold mb-4 text-teal-600" data-aos="zoom-in">
          Coming Soon
        </h2>

        <div className="mb-4">
          <p className="text-lg font-semibold mb-2">Contact Us:</p>
          <p className="flex items-center justify-center mb-1">
            <i className="fas fa-phone-alt mr-2 text-teal-500"></i>
            <span className="text-gray-700">+91 92541 47455</span>
          </p>
          <p className="flex items-center justify-center">
            <i className="fas fa-envelope mr-2 text-teal-500"></i>
            <span className="text-gray-700">info@shrisatyait.com</span>
          </p>
        </div>

        {/* Follow us Section */}
        <div className="mt-6">
          <p className="text-teal-500 font-semibold mb-2" data-aos="zoom-in">
            Follow us for updates:
          </p>
          <div className="flex space-x-4 justify-center">
            <a href="#" className="text-teal-600 hover:text-teal-800 transition">
              <i className="fab fa-facebook-f"></i>
            </a>
            <a href="#" className="text-teal-600 hover:text-teal-800 transition">
              <i className="fab fa-twitter"></i>
            </a>
            <a href="#" className="text-teal-600 hover:text-teal-800 transition">
              <i className="fab fa-instagram"></i>
            </a>
          </div>
        </div>

        {/* Privacy Policy Button */}
        <div className="mt-6">
          <Link
            to="/privacy-policy"
            className="inline-block bg-teal-500 text-white px-6 py-2 rounded-lg hover:bg-teal-600 transition"
          >
            Privacy Policy
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ComingSoon;
